// extracted by mini-css-extract-plugin
module.exports = {"headerStyle":"antd-pro-containers-group-add-styles-headerStyle"};